import { render, staticRenderFns } from "./StartFinishConfigRuntimeForm.vue?vue&type=template&id=572f6e9b&"
import script from "./StartFinishConfigRuntimeForm.vue?vue&type=script&lang=js&"
export * from "./StartFinishConfigRuntimeForm.vue?vue&type=script&lang=js&"
import style0 from "./StartFinishConfigRuntimeForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports